import { render, staticRenderFns } from "./layout-landingpage-navbar.vue?vue&type=template&id=3afc3910&"
import script from "./layout-landingpage-navbar.vue?vue&type=script&lang=js&"
export * from "./layout-landingpage-navbar.vue?vue&type=script&lang=js&"
import style0 from "./layout-landingpage-navbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports